<template>
  <div class="toAuth">
      <div class="currentTag">
          <div>信息</div>
          <div><i style="font-size:22px;cursor:pointer" class="el-icon-close" @click="$emit('update:authOrConfig','')"></i></div>
      </div>
      <div class="authTitle">
         <img src="../../../../static/publicNum.png" alt=""/>
         <div style="text-indent:6px">公众号</div>
      </div>
      <div class="content">
        <div class="contentTitle">公众平台账号授权</div>
        <div class="scanCodePanel">
            <div class="QRarea">
                <img src="" alt=""/>
                <div class="QRtip">使用公众平台绑定的管理员个人微信号扫描</div>
            </div>
            <el-popover
                placement="left-start"
                width="370"
                trigger="hover"
                content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                    <div slot="reference" class="publicNumInfo">
                        <div><img src="" alt=""/></div>
                        <div class="info">
                            <div class="publicName">店播云商城</div>
                            <div class="tag">
                                <span class="infoLabel">标签</span><span>购物超市</span>
                            </div>
                            <div class="breif">
                                <span class="infoLabel">简介</span><span>便利店的小型商城</span>
                            </div>
                        </div>
                    </div>
                    <slot>
                        <div class="hoverPublicNumDetail">
                           <div class="hoverTitle">
                               <img src="" alt="">
                               店播云商城
                           </div>
                           <div class="info">
                              <div>
                                  <span class="infoLabelHover">标签</span><span>购物超市</span>
                              </div>
                              <div>
                                  <span class="infoLabelHover">简介</span><span>购物超市</span>
                              </div>
                              <div>
                                  <span class="infoLabelHover">企业名</span><span>购物超市</span>
                              </div>
                              <div>
                                  <span class="infoLabelHover">企业营业执照号</span><span>购物超市</span>
                              </div>
                              <div>
                                  <span class="infoLabelHover">企业类型</span><span>购物超市</span>
                              </div>
                              <div>
                                  <span class="infoLabelHover">经营范围</span><span>计算机网络信息技术领域内的技术研发、技术咨询、技术转让、技术服务;计算机软件的技术研发、技术咨询、技术服务;广告的设计、制作、代理、发布;图文设计;电脑动画设计;企业形象策划;市场营销策划;商务信息咨询;企业管理咨询;会务服务;展览展示服务;计算机的维修;计算机系统集成;计算机网络工程的设计、施工;计算机、软件及辅助设备、通信设备、通讯器材的销售。(依法须经批准的项目,经相关部门批准后方可开展经营活动)</span>
                              </div>
                              <div>
                                  <span class="infoLabelHover">企业成立日期</span><span>计算机网络信息技术领域内的技术研发、技术咨询、技术转让、技术服务;计算机软件的技术研发、技术咨询、技术服务;广告的设计、制作、代理、发布;图文设计;电脑动画设计;企业形象策划;市场营销策划;商务信息咨询;企业管理咨询;会务服务;展览展示服务;计算机的维修;计算机系统集成;计算机网络工程的设计、施工;计算机、软件及辅助设备、通信设备、通讯器材的销售。(依法须经批准的项目,经相关部门批准后方可开展经营活动)</span>
                              </div>
                              <div>
                                  <span class="infoLabelHover">企业营业期限</span><span>购物超市</span>
                              </div>
                           </div>
                        </div>
                    </slot>
            </el-popover>
        </div>
      </div>
      <div class="footerCopyright">
        <div class="allAgreement">
            <span>关于腾讯</span><span class="divider">|</span><span>服务协议</span><span class="divider">|</span><span>运营中心</span><span class="divider">|</span><span>腾讯客服</span><span class="divider">|</span><span>侵权投诉</span>
        </div>
        <div class="copyrightDate">
            Copyright © 2012-2021 Tencent. All Rights Reserved.
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props:['authOrConfig']
}
</script>

<style scoped>
.toAuth .currentTag{
    height: 43px;
    line-height: 42px;
    padding: 0px 20px 0px 20px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    border-bottom: 1px solid #eeeeee;
}
.toAuth .authTitle{
    height:56px;
    padding-left:48px;
    background-color: #ffffff;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    font-size:22px
}
.authTitle img{
    width: 32px;
    height: 32px;
}

.content{
    margin-top:32px;
}
.content .contentTitle{
    color:#353535;
    font-size:21px;
    text-align: center;
}
.content .scanCodePanel{
  width:350px;
  margin:0 auto;
  margin-top:36px;
  border:1px solid #e1e1e1;
}
.content .scanCodePanel .QRarea{
    padding:30px 40px;
    background-color: #ffffff;

    text-align: center;
}
.content .scanCodePanel .QRarea img{
    width: 200px;
    height: 200px;
}
.content .scanCodePanel .publicNumInfo{
    padding:40px 15px;
    display: flex;
    flex-flow: row nowrap;
    background-color: #f3f3f3;
}
.content .scanCodePanel .publicNumInfo img{
    width: 40px;
    height: 40px;
}
.content .scanCodePanel .publicNumInfo .info{
    margin-left:14px;
}
.content .scanCodePanel .publicNumInfo .info .publicName{
    color:#353535;
}
.infoLabel{
    color:#9a9a9a;
    margin-right:14px;
}

.footerCopyright{
    margin-top:80px;
    padding:16px 45px 40px 45px;

    color:#9a9a9a;
    font-size: 12px;
}
.footerCopyright .allAgreement{
    border-bottom: 1px solid #e4e8eb;
    padding-bottom: 8px;
}

.footerCopyright .allAgreement .divider{
    margin:0px 6px 0px 6px;
}
.footerCopyright .allAgreement span:nth-child(odd){
    cursor: pointer;
    
}
.footerCopyright .copyrightDate{
    margin-top:8px;
}

.hoverPublicNumDetail{
  color:#353535;
  font-size:14px;
}
.hoverPublicNumDetail .hoverTitle img{
    width: 40px;
    height: 40px;
    vertical-align: text-bottom;
}
.hoverPublicNumDetail .info{
    margin-top:40px;
}
.infoLabelHover{
    color:#9a9a9a;
    margin-right:14px;
    display: inline-block;
    width: 84px;
}
.hoverPublicNumDetail .info div{
    margin-bottom: 5px;
    display: flex;
    flex-flow: row nowrap;
}
.hoverPublicNumDetail .info div span:nth-of-type(2){
    display: inline-block;
    width:68%;
}

</style>


// WEBPACK FOOTER //
// src/page/system/wechat/ToAuth.vue